import { render } from "./ModalInformativoProdutos.vue?vue&type=template&id=21c25dbe"
import script from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"
export * from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"

import "./ModalInformativoProdutos.vue?vue&type=style&index=0&id=21c25dbe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__